export const c8s = (...opts: (string | boolean | undefined | null)[]) => {
  return opts.filter(Boolean).join(" ");
};
